import { gql, type OperationVariables } from '@apollo/client';
import type ICompanySettings from '@sharedInterfaces/ICompanySettings';
import Company, { type OU } from '@src/Objects/Company';
import { companySettingsGql } from '../Company/getCompanySettings';
import GraphQL from '../graphQL';

const query = gql`
mutation createOUs($newOUs: [NewOU!]!) {
    createOUs(newOUs: $newOUs) 
    ${companySettingsGql}
},
`;

export default async function createOUs(newOUs: OU[]) {
    const variables: OperationVariables = {
        newOUs: newOUs.map((o) => o.generateDTO()),
    };
    return GraphQL.mutate<ICompanySettings>(query, variables).then((c) => new Company(c));
}
